/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type UserSettingEntity, userSettingSchema } from '@axiom/domain';
import { makeRequired } from '@axiom/types';

/** UpdateUserSettingResponse — dark-roast DTO: UserSettingResponseDto */
export const updateUserSettingResponseSchema = userSettingSchema.pick({ "appId": true, "createdAt": true, "env": true, "id": true, "name": true, "updatedAt": true, "userId": true, "value": true }).extend({ "createdAt": makeRequired(userSettingSchema.shape.createdAt), "updatedAt": makeRequired(userSettingSchema.shape.updatedAt) });
export type UpdateUserSettingResponse = Pick<UserSettingEntity, "appId" | "createdAt" | "env" | "id" | "name" | "updatedAt" | "userId" | "value"> & z.infer<typeof updateUserSettingResponseSchema>;
